enum ApiStatus {
  INITIAL = "initial",
  LOADING = "loading",
  SUCCESS = "success",
  FAILURE = "failure",
}

export default ApiStatus;
